module.exports = __webpack_public_path__ + "img/13.c66e7702.jpg";